
// Lastly, we import everything and export a single object

import enUsTranslations from './en-us'
import ptBrTranslations from './pt-br'

export default {
  'en-US': enUsTranslations,
  'pt-BR': ptBrTranslations
}